import { AlertType as o } from "@jetbrains/ring-ui-built/components/alert/alert.js";
import n from "@jetbrains/ring-ui-built/components/alert-service/alert-service.js";
const c = 4e3, s = (r, e, t, A = c) => n.addAlert(r, e, A, t), h = (r, e, t) => n.addAlert(r, o.ERROR, e, t), m = (r, e, t) => s(r, o.MESSAGE, t, e), w = (r, e, t) => s(r, o.WARNING, t, e), E = (r, e, t) => s(r, o.SUCCESS, t, e), a = (r, e, t) => s(r, o.LOADING, t, e), d = (r, e, t) => s(r, o.INFO, t, e), i = (r) => {
  n.remove(r);
}, S = () => {
  n.showingAlerts = [], n.renderAlerts();
};
export {
  i as removeAlert,
  S as removeAllAlerts,
  h as showError,
  d as showInfo,
  a as showLoading,
  m as showMessage,
  E as showSuccess,
  w as showWarning
};
